<template>
  <div class="row">
    <div v-if="isLoading">
      loading...
    </div>
    <div v-else>
      <p>{{balanceInfo.CustomerName}}</p>
      <table class="table-cell-responsive table-default text-center text-sm-left">
        <thead class="hidden-xs hidden-sm">
          <tr>
            <th v-if="balanceInfo.AmountNotYetDue">{{balanceInfo.AmountNotYetDue.Name}}</th>
            <th>{{balanceInfo.CurrentBalance.Name}}</th>
            <template v-for="(item, i) in balanceInfo.OtherBalances">
              <th>{{item.Name}}</th>
            </template>
            <th>{{ amountdueLabel }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="col-xs-12 col-sm-12 col-md-1 md-table-cell" v-if="balanceInfo.AmountNotYetDue">
              <b class="md-hidden">{{balanceInfo.AmountNotYetDue.Name}}:</b>
              {{ currencySign }}{{balanceInfo.AmountNotYetDue.Amount.toFixed(2)}}
            </td>
            <td class="col-xs-12 col-sm-12 col-md-1 md-table-cell">
              <b class="md-hidden">{{balanceInfo.CustomerName}}:</b>
              {{ currencySign }}{{balanceInfo.CurrentBalance.Amount.toFixed(2)}}
            </td>
            <template v-for="(item, i) in balanceInfo.OtherBalances">
              <td class="col-xs-12 col-sm-12 col-md-1 md-table-cell">
                <b class="md-hidden">{{item.Name}}:</b>
                {{ currencySign }}{{item.Amount.toFixed(2)}}
              </td>
            </template>
            <td class="col-xs-12 col-sm-12 col-md-1 md-table-cell">
              <b class="md-hidden">{{ amountdueLabel }}:</b>
              {{ currencySign }}{{balanceInfo.AmountDue.toFixed(2)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import { TransactionService } from "../../Models/Transaction/TransactionService";

  export default {
    name: "CustomerBalanceInfo",
    props: {
      currencySign: {
        type: String,
        default: () => ''
      },
      amountdueLabel: {
        type: String,
        default: () => ''
      }
    },
    data() {
      return {
        balanceInfo: {
          CustomerName: '',
          AmountDue: 0,
          AmountNotYetDue: {
            Name: '',
            Amount: 0,
          },
          CurrentBalance: {
            Name: '',
            Amount: 0,
          },
          OtherBalances: []
        },
        isLoading: false,
      };
    },
    computed: {
      transactionService: function () {
        return new TransactionService();
      }
    },
    mounted() {
      this.isLoading = true;
      this.getCurrentCustomerBalanceInfomation().then(({ data }) => {
        this.balanceInfo = data;
        this.isLoading = false;
      });
    },
    methods: {
      getCurrentCustomerBalanceInfomation() {
        return this.transactionService.getCurrentCustomerBalanceInfomation();
      }
    }
  };
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// EcomCore/Components/Transactions/CustomerBalanceInfo.vue